import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import { Styles } from "./styles/numberCounter.js";

class SchoolNumberCounter extends Component {
    render() {
        return (
            <Styles>
                {/* Counter Area */}
                <section className="counter-area" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/school-background.jpg)` }}>
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="sec-title text-center">
                                    <h4>A Glimpse of Our Achievements Through the Years</h4>
                                </div>
                            </Col>
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-school"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={ 27 } duration={3} delay={1} />+</h4>
                                        <p>Classrooms</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-book"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={1500} duration={4} delay={1} />+</h4>
                                        <p>Library Books</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-laptop"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={15} duration={3} delay={1} />+</h4>
                                        <p>Computers</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="3" xs="6">
                                <div className="counter-box">
                                    <div className="counter-icon">
                                        <i className="las la-chalkboard-teacher"></i>
                                    </div>
                                    <div className="counter-number">
                                        <h4><CountUp end={43} duration={2} delay={1} />+</h4>
                                        <p>Qualified Teachers</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
    }
}

export default SchoolNumberCounter;